module.exports = __webpack_public_path__ + "img/247-somaliland.8d00822d.svg";